var render = function render(){var _vm=this,_c=_vm._self._c;return _c('please-select-utility',{attrs:{"alert-class":"ma-3"}},[_c(_vm.component,_vm._b({tag:"component"},'component',_vm.$route.params,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }